// extracted by mini-css-extract-plugin
module.exports = {"item":"TextItem__item__1n3qe"};